import React, { useEffect, useState } from 'react';
import { Sidebar } from './Sidebar';
import { Gheader } from './Gheader';
import styles from './Guest.module.css';
import FilterButton from './FilterButton';
import RateTable from './Table';
import GuestModel from './GuestModel';
import apiService from '../api/apiService';
import { ToastContainer } from 'react-toastify';

export const Rate = () => {
  const hotelId = localStorage.getItem('hotel');
  const [isModelOpen, setIsModelOpen] = useState(false);
  const [guests, setGuests] = useState([]);
  const addGuest = newGuest => {
    setGuests([newGuest, ...guests]);
  };

  /* Fetching Rates from endpoint and updating local state */
  useEffect(() => {
    fetchGuests();
  }, []);

  const fetchGuests = async () => {
    try {
      const response = await apiService.get(`/guests/?hotel=${hotelId}`);
      setGuests(response);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <div className={styles.gheader}>
        <div className={styles.dashboardContainer}>
          <Sidebar />
          <div className={styles.mainContent}>
            <Gheader />
            <h3 className="ps-2 ps-md-0">Guests</h3>
            <div className={`${styles.buttonContainer} ps-2 ps-md-0`}>
              <button
                className={styles.addGuestButton}
                onClick={() => setIsModelOpen(true)}
              >
                Add Guests
              </button>
              {/* <FilterButton /> */}
            </div>

            <RateTable data={guests} setData={setGuests} hotelId={hotelId} />

            {isModelOpen && (
              <GuestModel
                isOpen={isModelOpen}
                onClose={() => setIsModelOpen(false)}
                onSave={addGuest}
                onGuestAdded={fetchGuests}
                hotelId={hotelId}
              />
            )}
          </div>
        </div>
      </div>
      <ToastContainer autoClose={1500} />
    </>
  );
};

export default Rate;
